import { render } from "./CreateTeam.vue?vue&type=template&id=3346bedf"
import script from "./CreateTeam.vue?vue&type=script&lang=js"
export * from "./CreateTeam.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__